module.exports = __webpack_public_path__ + "img/richarf-meier.f76b1712.png";